import { render, staticRenderFns } from "./Genre.vue?vue&type=template&id=57be8738&"
import script from "./Genre.vue?vue&type=script&lang=js&"
export * from "./Genre.vue?vue&type=script&lang=js&"
import style0 from "./Genre.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VExpandTransition,VMain})
